import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { getApiBaseUrl } from '../utils/apiBaseUrl';
import defaultLogo from '../images/logo.svg';

const BrandingContext = createContext({
  siteTitle: 'PLS',
  siteTagline: '',
  brandColor: '#0f766e',
  logoUrl: defaultLogo,
  hasCustomLogo: false,
  reload: () => {},
});

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState({
    siteTitle: 'PLS',
    siteTagline: '',
    brandColor: '#0f766e',
    logoUrl: defaultLogo,
    hasCustomLogo: false,
  });

  const applyBrandColor = (color) => {
    if (color && /^#[0-9A-Fa-f]{6}$/.test(color)) {
      document.documentElement.style.setProperty('--brand', color);
    }
  };

  const reload = useCallback(async () => {
    try {
      const res = await fetch(`${getApiBaseUrl()}v2/public/branding/`, {
        credentials: 'include',
      });
      const data = await res.json();
      const b = (data && data.branding) || {};
      // Nur Custom-Logo wenn API es wirklich hat — sonst Standard-PLS-Logo
      let logoUrl = defaultLogo;
      if (b.has_logo && b.logo_url) {
        const abs = b.logo_url.startsWith('http')
          ? b.logo_url
          : `${getApiBaseUrl().replace(/\/$/, '')}${b.logo_url}`;
        logoUrl = `${abs}${abs.includes('?') ? '&' : '?'}t=${Date.now()}`;
      }
      const next = {
        siteTitle: b.site_title || 'PLS',
        siteTagline: b.site_tagline || '',
        brandColor: b.brand_color || '#0f766e',
        logoUrl,
        hasCustomLogo: !!b.has_logo,
      };
      setBranding(next);
      applyBrandColor(next.brandColor);
      if (next.siteTitle) {
        document.title = next.siteTitle;
      }
      if (b.has_favicon && b.favicon_url) {
        let link = document.querySelector("link[rel='icon']");
        if (!link) {
          link = document.createElement('link');
          link.rel = 'icon';
          document.head.appendChild(link);
        }
        link.href = `${getApiBaseUrl().replace(/\/$/, '')}${b.favicon_url}?t=${Date.now()}`;
      }
    } catch (_) {
      /* Default-Branding behalten */
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return (
    <BrandingContext.Provider value={{ ...branding, reload }}>
      {children}
    </BrandingContext.Provider>
  );
}

export function useBranding() {
  return useContext(BrandingContext);
}

export default BrandingContext;
